import { Container, List, useMantineTheme } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

function Emphasis({ children }: { children: ReactNode }) {
  const theme = useMantineTheme();
  return (
    <span style={{ fontWeight: 'bold', color: theme.other.colors.primary }}>
      {children}
    </span>
  );
}

function DescriptionList() {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { text } = theme.other.colors;

  return (
    <Container
      size='sm'
      px='md'
      sx={{
        'marginTop': 16,
        'maxWidth': 640,
        '@media (min-width: 640px)': {
          marginTop: 24,
        },
      }}
    >
      <List spacing={12} sx={{ color: text }}>
        <List.Item>
          {t('what is morph')}
          <Emphasis>{t('allele')}</Emphasis>
          {t('morph which cannot calc')}
          {t('can not calc')}
        </List.Item>
        <List.Item>
          {t('if input nothing')}
          <Emphasis>{t('normal')}</Emphasis>
          {t('will be calc')}
        </List.Item>
        <List.Item>
          {t('het is')}
          <Emphasis>{t('having a morph')}</Emphasis>
          {t('as')}
          <Emphasis>{t('can not calc')}</Emphasis>
        </List.Item>
        <List.Item>{t('list occurred by')}</List.Item>
        <List.Item>
          {t('is not affected sex')}
          {t('free to type it')}
        </List.Item>
      </List>
    </Container>
  );
}

export default DescriptionList;
